import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import countryData from "../data/country_region_data.json"

// Connects to data-controller="country-state"
export default class extends Controller {
  static targets = ["country", "state"]
  static values = {
    initialCountry: String,
    initialState: String,
    countryPlaceholder: String,
    statePlaceholder: String,
  }

  connect() {
    this.countryData = countryData
    this.initCountrySelect()
  }

  initCountrySelect() {
    const countryOptions = this.countryData.map(c => ({ value: c.countryName, text: c.countryName }))

    // Sort countries with United States first, then alphabetically
    countryOptions.sort((a, b) => {
      if (a.text === 'United States') return -1
      if (b.text === 'United States') return 1
      return a.text.localeCompare(b.text)
    })

    // Initialize country select
    this.countryTom = new TomSelect(this.countryTarget, {
      plugins: ['dropdown_input'],
      placeholder: this.countryPlaceholderValue,
      searchField: ['text'],
      create: false,
      options: countryOptions,
      onChange: (value) => {
        this.stateTom?.clear()
        this.updateStates(value)
      }
    })

    // Set initial country value if it exists
    if (this.hasInitialCountryValue) {
      this.countryTom.setValue(this.initialCountryValue)
      this.updateStates(this.initialCountryValue)
    }
  }

  updateStates(countryCode) {
    // Some forms (e.g. the user profile) mount this controller with only a
    // country selector and no state field. Skip state handling when absent.
    if (!this.hasStateTarget) return

    const country = this.countryData.find(c => c.countryName === countryCode)
    const stateOptions = country && country.regions ? country.regions.map(r => ({ value: r.name, text: r.name })) : []

    // Clear existing options
    this.stateTarget.innerHTML = ""
    
    // Add new options
    stateOptions.forEach(opt => {
      const option = document.createElement("option")
      option.value = opt.value
      option.text = opt.text
      this.stateTarget.appendChild(option)
    })

    // Destroy existing Tom Select instance if it exists
    if (this.stateTom) this.stateTom.destroy()

    // Initialize new Tom Select with the updated options
    this.stateTom = new TomSelect(this.stateTarget, {
      plugins: ['dropdown_input'],
      placeholder:  this.statePlaceholderValue,
      searchField: ['text'],
      create: false,
      sortField: {
        field: "text",
        direction: "asc"
      },
      options: stateOptions,
      items: [],
      clearOnSelect: true
    })

    // Set initial state value if it exists and matches current country
    if (this.hasInitialStateValue && countryCode === this.initialCountryValue) {
      this.stateTom.setValue(this.initialStateValue)
    }
  }
}
